import styled from 'styled-components';

export const StyledSlider = styled.div`
  position: relative;
`;
